
//Address types
export const addressTypes = {
  TEAMS: 'teams',
  SLACK: 'slack',
  SMS: 'sms',
  WHATSAPP: 'sms_whatsapp',
  EMAIL: 'email',
  MESSENGER: 'messenger',
}

//Address type options array
export const addressTypeOptions = [
  {label: 'Teams', value: addressTypes.TEAMS},
  {label: 'Slack', value: addressTypes.SLACK},
  {label: 'SMS', value: addressTypes.SMS},
  {label: 'WhatsApp', value: addressTypes.WHATSAPP},
  {label: 'Email', value: addressTypes.EMAIL},
  {label: 'Arist Messenger', value: addressTypes.MESSENGER},
]
